import React from "react";

interface UploadButtonProps {
  isUploading: boolean;
  hasFiles: boolean;
  hasErrors: boolean;
  fileCount: number;
  onUpload: () => void;
}

export const UploadButton: React.FC<UploadButtonProps> = ({
  isUploading,
  hasFiles,
  hasErrors,
  fileCount,
  onUpload
}) => {
  const isDisabled = isUploading || !hasFiles || hasErrors;

  return (
    <button
      onClick={onUpload}
      disabled={isDisabled}
      style={{
        width: "100%",
        padding: "15px",
        backgroundColor: isDisabled ? "#6c757d" : "#007bff",
        color: "white",
        border: "none",
        borderRadius: "6px",
        cursor: isDisabled ? "not-allowed" : "pointer",
        fontSize: "16px",
        fontWeight: "500",
        transition: "background-color 0.3s ease"
      }}
    >
      {isUploading ? "업로드 중..." : `${fileCount}개 파일 업로드`}
    </button>
  );
};
